<nav class="navbar navbar-expand-lg navbar-dark bg-primary mb-1">
	<div class="row g-1" style="display: flex; width: 100%;padding: 0px 20px;">

		<div class="col-6 col-md-1">
			<div style="display: flex; align-items: center; justify-content: center;">
				<div><a href="#"><img style="height: 50px;" src="https://delta.mycapx.com/assets/images/mycapx_cappy.png"></a></div>
				<div><a href="#"><img style="height: 50px;" src="https://delta.mycapx.com/assets/images/mcxLogo.png"></a></div>

			</div>

		</div>
		<div class="col-6 col-md-8" style="position: relative; overflow:hidden;display: flex; align-items: center;">
			<div style="font-size: 24px;opacity: .1;margin-top: -12px;position: absolute; letter-spacing: .3em;color: #FFF;margin-left: 10px;font-weight: 100;text-transform: uppercase;padding: 0px 12px;">
				Tenant Portal v1.2
			</div>
			<div class="burningOrgange" style="font-size: .9rem;; letter-spacing: .3em;color: #FFF;margin-left: 10px;font-weight: 100;text-transform: uppercase;padding: 0px 12px;">
				Tenant Portal v1.2
			</div>
		</div>
		<div class="col-12 col-md-3">
			<div class="mobileMenuToggle" (click)="menuOpen = !menuOpen" style="text-align: right; color: #FFF; cursor: pointer" >
				<i class="fa fa-bars" aria-hidden="true"></i> Menu
			</div>
			<div [ngStyle]="{ height: menuOpen ? '100%' : '0px', paddingBottom: menuOpen ? '24px' : '0px' }" class="mobileMenu row g-1" style="text-transform: uppercase; color: #FFF; display: flex; flex: 20; justify-content: space-between;" >

				<div class="col-12 col-md-4">
					<a class="navButton nav-link d-inline-block" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Login</a>
				</div>
				<div class="col-12 col-md-4">
					<a class="navButton nav-link d-inline-block" routerLink="/my-work-orders" routerLinkActive="active">My Work Orders</a>
				</div>
				<div class="col-12 col-md-4">
					<a class="navButton nav-link d-inline-block" routerLink="/request-work-orders" routerLinkActive="active">Request Work Orders</a>
				</div>

			</div>
		</div>

	</div>
</nav>
